var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mapbox',{staticClass:"map",attrs:{"access-token":_vm.accessToken,"map-options":{
			style:   'mapbox://styles/mapbox/outdoors-v11',
			center:  _vm.options.center,
			zoom:    _vm.options.zoom,
			maxZoom: _vm.options.maxZoom,
		},"attribution-control":{
			show: false,
			position: 'bottom-right',
      	}},on:{"map-init":_vm.onInitialized,"map-load":_vm.onLoaded,"map-styledata":_vm.onStyleLoaded,"map-click":_vm.onClick,"map-mousemove":_vm.onMouseMove,"map-mouseleave":_vm.onMouseLeave}})}
var staticRenderFns = []

export { render, staticRenderFns }